export const calcularComision = (monto, porcentaje) => {
  return Math.round(monto * (porcentaje / 100) * 100) / 100;
};

export const calcularTotalPropietario = (monto, comision) => {
  return monto - comision;
};

export const calcularProximoAumento = (fechaActual, frecuencia) => {
  const meses = {
    TRIMESTRAL: 3,
    CUATRIMESTRAL: 4,
    SEMESTRAL: 6,
    ANUAL: 12,
  };
  const delta = meses[frecuencia] || 3;
  const [y, m, d] = String(fechaActual).split("-").map(Number);
  // Build a local Date at noon so the +N-month shift never crosses a UTC day
  // boundary on toISOString().
  const fecha = new Date(y, (m || 1) - 1, d || 1, 12);
  fecha.setMonth(fecha.getMonth() + delta);
  const yy = fecha.getFullYear();
  const mm = String(fecha.getMonth() + 1).padStart(2, "0");
  const dd = String(fecha.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
};

export const formatMonto = (monto, moneda = "ARS") => {
  if (!monto && monto !== 0) return "-";
  const num = Number(monto);
  if (moneda === "USD") {
    return `U$D ${num.toLocaleString("es-AR", { minimumFractionDigits: 0 })}`;
  }
  return `$ ${num.toLocaleString("es-AR", { minimumFractionDigits: 0 })}`;
};

// "2026-07-01" -> "01/07/26"
export const formatFechaCorta = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y.slice(2)}`;
};

export const diasHastaFecha = (fecha) => {
  if (!fecha) return null;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const target = new Date(fecha);
  target.setHours(0, 0, 0, 0);
  return Math.ceil((target - hoy) / (1000 * 60 * 60 * 24));
};

export const estadoVencimiento = (fechaVencimiento, diasAlerta = 30) => {
  const dias = diasHastaFecha(fechaVencimiento);
  if (dias === null) return "SIN_FECHA";
  if (dias < 0) return "VENCIDO";
  if (dias <= diasAlerta) return "POR_VENCER";
  return "VIGENTE";
};
